/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderDirectoryContactType } from './ProviderDirectoryContactType';
import {
    ProviderDirectoryContactTypeFromJSON,
    ProviderDirectoryContactTypeFromJSONTyped,
    ProviderDirectoryContactTypeToJSON,
    ProviderDirectoryContactTypeToJSONTyped,
} from './ProviderDirectoryContactType';

/**
 * 
 * @export
 * @interface UpdateDirectoryContactRequest
 */
export interface UpdateDirectoryContactRequest {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    position?: string | null;
    /**
     * 
     */
    email?: string | null;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    contact_type?: ProviderDirectoryContactType;
}



/**
 * Check if a given object implements the UpdateDirectoryContactRequest interface.
 */
export function instanceOfUpdateDirectoryContactRequest(value: object): value is UpdateDirectoryContactRequest {
    return true;
}

export function UpdateDirectoryContactRequestFromJSON(json: any): UpdateDirectoryContactRequest {
    return UpdateDirectoryContactRequestFromJSONTyped(json, false);
}

export function UpdateDirectoryContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDirectoryContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'position': json['position'] === undefined ? undefined : json['position'] === null ? null : json['position'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'contact_type': json['contact_type'] == null ? undefined : ProviderDirectoryContactTypeFromJSON(json['contact_type']),
    };
}

export function UpdateDirectoryContactRequestToJSON(json: any): UpdateDirectoryContactRequest {
    return UpdateDirectoryContactRequestToJSONTyped(json, false);
}

export function UpdateDirectoryContactRequestToJSONTyped(value?: UpdateDirectoryContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'position': value['position'],
        'email': value['email'],
        'phone': value['phone'],
        'contact_type': ProviderDirectoryContactTypeToJSON(value['contact_type']),
    };
}

